import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_PUT_SET_LANGUAGE, KEY_PUT_SET_LANGUAGE } from '../constants';
import { MOCK_RESPONSE_PUT_SET_LANGUAGE } from '../mocks';

export type CallParamsPutSetLanguage = {
  language: 'it' | 'en' | 'fr' | 'es';
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponsePutSetLanguage = unknown;

type CallErrorPutSetLanguage = GenericApiError;

type CallSelectorsPutSetLanguage = unknown;

export const putSetLanguageCall = createGeneralCall<
  CallParamsPutSetLanguage,
  CallResponsePutSetLanguage,
  CallErrorPutSetLanguage,
  CallSelectorsPutSetLanguage
>({
  id: KEY_PUT_SET_LANGUAGE,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_PUT_SET_LANGUAGE(org as unknown as string);
  },
  method: 'put',
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  successMock: IS_MOCK_ENABLED({ avoidMockOnDemoMode: true })
    ? MOCK_RESPONSE_PUT_SET_LANGUAGE
    : MOCK_RESPONSE_PUT_SET_LANGUAGE,
});
